export default class StoryboardRoleService {
  static canManageStoryboard(role?: string): boolean {
    return role?.toLowerCase() === "owner";
  }

  static canEditStoryboard(role?: string): boolean {
    const r = role?.toLowerCase();
    return r === "owner" || r === "editor";
  }
}

export const canEdit = (role?: string): boolean =>
  StoryboardRoleService.canEditStoryboard(role);

export const canManage = (role?: string): boolean =>
  StoryboardRoleService.canManageStoryboard(role);
